import type { PersonaCharacter } from "@shared/schema";
import { AD_IDENTITY_PACK_STALE_MS } from "@shared/ad-identity-pack";

export const AD_IDENTITY_IMAGE_ROLES = [
  "Chest-up portrait",
  "Full-body standing view",
  "Smiling three-quarter portrait",
] as const;

export function resolveAdIdentityPackView(character: PersonaCharacter | null, now = Date.now()) {
  const urls = character?.adIdentityPackUrls;
  const avatarChanged = !!character?.adIdentityPackAvatarUrl
    && character.adIdentityPackAvatarUrl !== character.avatarUrl;
  const images = !!character?.avatarUrl && character.adIdentityPackAvatarUrl === character.avatarUrl
    && Array.isArray(urls) && urls.length === 3
    && urls.every((url) => typeof url === "string" && url.trim())
    ? urls : [];
  const ready = character?.adIdentityPackStatus === "ready" && images.length === 3;
  const startedAt = character?.adIdentityPackStartedAt
    ? new Date(character.adIdentityPackStartedAt).getTime() : NaN;
  const generating = character?.adIdentityPackStatus === "generating";
  const active = generating && Number.isFinite(startedAt)
    && now - startedAt < AD_IDENTITY_PACK_STALE_MS;
  const state = avatarChanged ? "stale" : active ? "generating"
    : generating ? "interrupted" : character?.adIdentityPackStatus === "failed"
      ? "failed" : ready ? "ready" : "missing";
  return { images, ready, active, state };
}